var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInsight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 41.3 41.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M20.65,7.74c-.17,0-.31-.14-.31-.31v-1.51c0-.17.14-.31.31-.31s.31.14.31.31v1.51c0,.17-.14.31-.31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M27.7,10.66c-.08,0-.16-.03-.22-.09-.12-.12-.12-.31,0-.43l1.07-1.07c.12-.12.31-.12.43,0,.12.12.12.31,0,.43l-1.07,1.07c-.06.06-.14.09-.22.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.53,25.83c-.08,0-.16-.03-.22-.09-.12-.12-.12-.31,0-.43l1.07-1.07c.12-.12.31-.12.43,0,.12.12.12.31,0,.43l-1.07,1.07c-.06.06-.14.09-.22.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.13,17.71h-1.51c-.17,0-.31-.14-.31-.31s.14-.31.31-.31h1.51c.17,0,.31.14.31.31s-.14.31-.31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.68,17.71h-1.51c-.17,0-.31-.14-.31-.31s.14-.31.31-.31h1.51c.17,0,.31.14.31.31s-.14.31-.31.31Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M28.77,25.83c-.08,0-.16-.03-.22-.09l-1.07-1.07c-.12-.12-.12-.31,0-.43.12-.12.31-.12.43,0l1.07,1.07c.12.12.12.31,0,.43-.06.06-.14.09-.22.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M13.6,10.66c-.08,0-.16-.03-.22-.09l-1.07-1.07c-.12-.12-.12-.31,0-.43.12-.12.31-.12.43,0l1.07,1.07c.12.12.12.31,0,.43-.06.06-.14.09-.22.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M24.5,8.51s-.08,0-.12-.02c-.16-.07-.23-.24-.16-.4l.58-1.39c.07-.16.25-.23.4-.16.16.07.23.24.16.4l-.58,1.39c-.05.12-.16.19-.28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M29.88,13.93c-.12,0-.23-.07-.28-.19-.06-.16.01-.34.17-.4l1.4-.57c.16-.06.34.01.4.17.06.16-.01.34-.17.4l-1.4.57s-.08.02-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.03,22.07c-.12,0-.23-.07-.28-.19-.06-.16.01-.34.17-.4l1.4-.57c.16-.06.34.01.4.17.06.16-.01.34-.17.4l-1.4.57s-.08.02-.12.02Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.24,22.15s-.08,0-.12-.02l-1.39-.58c-.16-.07-.23-.24-.16-.4.07-.16.24-.23.4-.16l1.39.58c.16.07.23.24.16.4-.05.12-.16.19-.28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11.45,13.86s-.08,0-.12-.02l-1.39-.58c-.16-.07-.23-.24-.16-.4.07-.16.24-.23.4-.16l1.39.58c.16.07.23.24.16.4-.05.12-.16.19-.28.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.87,8.48c-.12,0-.23-.07-.28-.19l-.57-1.4c-.06-.16.01-.34.17-.4.16-.06.34.01.4.17l.57,1.4c.06.16-.01.34-.17.4-.04.02-.08.02-.12.02Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.33,31.96h-5.17c-.29,0-.53-.24-.53-.53h0c0-.29.24-.53.53-.53h5.17c.29,0,.53.24.53.53h0c0,.29-.24.53-.53.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M23.33,33.62h-5.17c-.29,0-.53-.24-.53-.53h0c0-.29.24-.53.53-.53h5.17c.29,0,.53.24.53.53h0c0,.29-.24.53-.53.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.49,34.25c-.13,0-.22.12-.2.24.13.68.72,1.2,1.44,1.2s1.31-.51,1.44-1.2c.02-.13-.07-.24-.2-.24h-2.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M22.78,30.24h-4.15c-.72,0-1.32-.56-1.38-1.28-.18-2.34-1.13-3.82-2.14-5.39-1.1-1.71-2.24-3.48-2.24-6.34,0-3.86,2.76-7.12,6.57-7.73.89-.14,1.83-.13,2.71.03,3.7.69,6.39,3.93,6.39,7.7,0,2.86-1.14,4.63-2.24,6.34-1.01,1.57-1.97,3.05-2.14,5.39-.05.72-.66,1.28-1.38,1.28ZM20.71,10.41c-.37,0-.74.03-1.1.09-3.31.54-5.72,3.36-5.72,6.73,0,2.56,1.01,4.13,2.08,5.79,1.04,1.61,2.11,3.27,2.3,5.87.01.19.17.34.36.34h4.15c.19,0,.35-.14.36-.34.2-2.6,1.27-4.26,2.3-5.87,1.07-1.66,2.08-3.23,2.08-5.79,0-3.28-2.34-6.1-5.55-6.7-.41-.08-.84-.12-1.26-.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M16.91,22.14c-.16,0-.31-.07-.41-.21-2.83-3.89-.74-7.54-.65-7.69.14-.24.46-.32.7-.18.24.14.32.45.18.7-.08.13-1.83,3.24.6,6.58.17.23.12.55-.11.71-.09.07-.2.1-.3.1Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsight);
export default __webpack_public_path__ + "static/media/insight.460b469b9950247c38df2658310d710a.svg";
export { ForwardRef as ReactComponent };